module.exports = __webpack_public_path__ + "static/media/right-thin-arrow.30549127.svg";